export default class UserReview extends HTMLElement {

    constructor() {
        super();
        this.imageGalleryList = null;
        this.colors = ['info', 'info-dark', 'success', 'success-dark', 'warning', 'danger', 'danger-dark', 'delta'];
        this.avatarClasses = 'bg-' + this.colors[Math.floor(Math.random() * this.colors.length)] + ' alias-summary';
        this.highlighted = this.getAttribute('highlighted') === 'true';
        this.COMMENT_MIN_CHAR_TO_COLLAPSE = 100;
        this.translateCommentClick = null;
        this.showTranslateReviews = this.hasAttribute('show-translate-reviews');
        this.isGalleryReview = false;
    }

    static get observedAttributes() {
        return ['stylesheet', 'translations', 'user-review', 'hotel-info', 'highlighted', 'review-id', 'review-web'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'stylesheet') {
            this.stylesheet = newValue;
        }
        if (name === 'translations') {
            this.translations = newValue ? JSON.parse(newValue) : newValue;
        }
        if (name === 'user-review') {
            this.userReview = newValue ? JSON.parse(newValue) : newValue;
        }
        if (name === 'hotel-info') {
            this.hotelInfo = newValue ? JSON.parse(newValue) : newValue;
        }
        if (name === 'highlighted') {
            this.highlighted = newValue ? JSON.parse(newValue) : newValue;
        }
        if (name === 'review-id') {
            this.reviewId = newValue ? JSON.parse(newValue) : newValue;
        }
        if (name === 'review-web') {
            this.reviewId = newValue ? JSON.parse(newValue) : newValue;
        }
    }

    connectedCallback() {
        this.stylesheet = this.getAttribute('stylesheet');
        this.userReview = JSON.parse(this.getAttribute('user-review'));

        if (this.getAttribute('hotel-info')) {
            this.hotelInfo = JSON.parse(this.getAttribute('hotel-info'));
        }
        this.hotelInfoVisible = this.getAttribute('hotel-info-visible');
        if (!this._checkElementExists(this.hotelInfo) && this.hotelInfoVisible) {
            let userReview = document.querySelector('user-review');
            if (this._checkElementExists(userReview)) {
                this.hotelInfo = JSON.parse(userReview.getAttribute('hotel-info'));
            }
        }
        this.slotted = this.getAttribute('slotted');
        if (this.getAttribute('translations')) {
            this.translations = JSON.parse(this.getAttribute('translations'));
        }

        const template = document.querySelector('#user-review');
        this._shadowRoot = this.attachShadow({mode: 'open'});
        let instance = template.content.cloneNode(true);
        const userCommentsTemplate = document.querySelector('#user-comments');
        instance.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = '';
        });

        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        if (!this.userReview.rating) {
            instance.querySelector('[name="rate-container"]').classList.remove('rate-container');
        }

        let numberOfReviews = 1;
        let hasMultipleReviews = false;
        if (this.userReview.multipleReviews && this.userReview.multipleReviews.length > 0) {
            numberOfReviews = this.userReview.multipleReviews.length;
            hasMultipleReviews = true;
        }

        if (this._checkElementExists(this.hotelInfo) && this.hotelInfoVisible) {
            const hotelInfoTemplate = document.querySelector('#review-hotel-info');
            const hotelInfoInstance = hotelInfoTemplate.content.cloneNode(true);
            hotelInfoInstance.querySelector("[name='hotel-name']").innerHTML = this.hotelInfo.name;
            hotelInfoInstance.querySelector("[name='hotel-location']").innerHTML = this.hotelInfo.location;
            let hotelCategoryContainer = hotelInfoInstance.querySelector('[name="hotel-category"]');
            this._fillHotelCategory(hotelCategoryContainer, 'star', this.hotelInfo.stars);
            this._fillHotelCategory(hotelCategoryContainer, 'keys', this.hotelInfo.keys);
            instance.querySelector('[name="review-hotel-info-container"]').appendChild(hotelInfoInstance);
        }

        const userReviewContainer = instance.querySelector('[name="user-review"]');
        let userWithComments = false;
        for (let i = 0; i < numberOfReviews; i++) {
            const userCommentsContainer = userCommentsTemplate.content.cloneNode(true);

            if (i > 0) {
                userCommentsContainer.querySelector('[name="user-comments"]').classList.add('multiple-reviews');
            }

            const userReview = hasMultipleReviews ? this.userReview.multipleReviews[i] : this.userReview;
            const commentRateContainer = userCommentsContainer.querySelector('[name="comment-rate-container"]');
            if (hasMultipleReviews) {
                userCommentsContainer.querySelectorAll('slot').forEach((slot) => {
                    slot.setAttribute('name', slot.getAttribute('name') + '-' + i);
                });

                commentRateContainer.innerHTML = userReview.rating;
            } else {
                commentRateContainer.remove();
            }
            if (!this._checkElementExists(userReview.negative_comment) &&
                !this._checkElementExists(userReview.positive_comment) &&
                ((userReview.comment === undefined) ||
                    (!this._checkElementExists(userReview.comment.comment) &&
                        !this._checkElementExists(userReview.comment.title)))
            ) {
                break;
            }

            userWithComments = true;

            this._fillComment(userCommentsContainer, userReview);
            this._fillPositiveComment(userCommentsContainer, userReview);
            this._fillNegativeComment(userCommentsContainer, userReview);

            const replyTemplate = userCommentsContainer.querySelector('[name="reply"]');
            const repliesContainer = userCommentsContainer.querySelector('[name="replies-container"]');
            let replyContainer;

            if (this._checkElementExists(userReview.replies)) {
                userReview.replies.forEach((reply, key) => {
                    replyContainer = this._fillReplyContainer(replyTemplate, reply)
                    repliesContainer.appendChild(replyContainer);
                });
            } else {
                repliesContainer.remove();
            }
            this._addOriginalCommentEventListener(userCommentsContainer, userReview);

            if (userReview.images && userReview.images.length > 0) {
                this._showSurveyImages(userReview.images, userCommentsContainer);
            } else {
                userCommentsContainer.querySelector('[name="survey-images-container"]').remove();
            }

            replyTemplate.remove();
            userReviewContainer.appendChild(userCommentsContainer);

            if (this.slotted == '0') {
                this._initializeUserReview(instance, this.userReview);
            }

            this.translateTextButton = instance.querySelector('[name="show-translate-text"]');
            this.userBottomContainer = instance.querySelector('[name="user-review-bottom"]');
            if (this.showTranslateReviews && this.translateTextButton && this.translateTextButton.innerHTML === '') {
                this.translateTextButton.innerHTML = this.translations['showTranslateReviews'];
                if (this.isGalleryReview) {
                    this.translateTextButton.classList.add('gallery-review')
                    this.userBottomContainer.classList.add('gallery-review-container')
                }
            } else {
                this.userBottomContainer.classList.remove('user-review-bottom-container')
            }

            if (this.showTranslateReviews && ((this._checkElementExists(userReview.negative_comment) && this._checkElementExists(userReview.negative_comment.default_comment)) || (this._checkElementExists(userReview.positive_comment) && this._checkElementExists(userReview.positive_comment.default_comment)))) {
                this._toggleOriginalComment(instance, 'none', 'block');
            }
        }

        if (userWithComments) {
            if (this.highlighted) {
                instance.querySelector('.user-review').classList.add("highlighted");
            }

            instance.querySelector('.general-review').classList.add('have-comments');
            if (this.getAttribute('collapsed')) {
                let userReview = hasMultipleReviews ? this.userReview.multipleReviews[0] : this.userReview;
                if (userReview && (this._checkElementExists(userReview.negative_comment) ||
                    (this._checkElementExists(userReview.positive_comment) &&
                        userReview.positive_comment.length > this.COMMENT_MIN_CHAR_TO_COLLAPSE))) {
                    this._addCollapse(instance, userReview);
                } else if (userReview && this._checkElementExists(userReview.positive_comment) &&
                    !this._checkElementExists(userReview.positive_comment.default_original_comment)) {
                    instance.querySelector('[name="user-review-bottom"]').classList.add('mb-3');
                }
            }
        } else {
            instance.querySelector("[name='alias-summary']").remove();
            instance.querySelector(".user-review").classList.add("no-comments");
        }

        let avatar = instance.querySelector("[name='alias-summary']");
        if (avatar && this.userReview.alias) {
            avatar.innerHTML = this.userReview.alias.charAt(0).toUpperCase();
            avatar.className = this.avatarClasses;
        }
        this._shadowRoot.appendChild(instance);
    }

    _initializeUserReview(instance, userReview) {
        if (this.userReview.rating) {
            instance.querySelector('[name="rate"]').innerHTML = this.userReview.rating;
        }
        instance.querySelector('[name="alias"]').innerHTML = this.userReview.alias;
        if (this.userReview.company_type && (typeof this.userReview.company_type !== 'undefined')) {
            instance.querySelector('[name="company_type"]').innerHTML = this.userReview.company_type;
        }
        instance.querySelector('[name="date"]').innerHTML = this.userReview.date_formatted;
        if (userReview.positive_comment) {
            instance.querySelector('[data-comment="positive-comment"]').innerHTML = userReview.positive_comment.default_comment;
            if (userReview.positive_comment.default_original_comment) {
                instance.querySelector('[name="original-positive-comment"]').innerHTML = userReview.positive_comment.default_original_comment;
            }
        }
        if (userReview.negative_comment) {
            instance.querySelector('[data-comment="negative-comment"]').innerHTML = userReview.negative_comment.default_comment;
            if (userReview.negative_comment.default_original_comment) {
                instance.querySelector('[name="original-negative-comment"]').innerHTML = userReview.negative_comment.default_original_comment;
            }
        }
    }

    _addOriginalCommentEventListener(instance, userReview) {
        if (userReview.allow_translation) {
            if (instance.querySelector('[data-entity="show-original-comment"]').innerHTML === '' &&
                instance.querySelector('[data-entity="hide-original-comment"]').innerHTML === '' &&
                this._checkElementExists(this.translations)) {
                instance.querySelector('[data-entity="show-original-comment"]').innerHTML = this.translations.showOriginalMessage;
                instance.querySelector('[data-entity="hide-original-comment"]').innerHTML = this.translations.hideOriginalMessage;
            }

            instance.querySelector('[data-entity="show-original-comment"]').setAttribute('review-id', userReview.id);
            instance.querySelector('[data-entity="hide-original-comment"]').setAttribute('review-id', userReview.id);

            instance.querySelector('[data-entity="show-original-comment"]').addEventListener("click", (event) => {
                this._toggleOriginalComment(
                    event.currentTarget.closest('[name="user-comments-container"]'),
                    'block',
                    'none'
                );
            });

            if (this.showTranslateReviews && ((this._checkElementExists(userReview.negative_comment) && this._checkElementExists(userReview.negative_comment.default_comment)) || (this._checkElementExists(userReview.positive_comment) && this._checkElementExists(userReview.positive_comment.default_comment)))) {
                instance.querySelector('[name="show-translate-text"]').style.display = '';
                instance.querySelector('[name="show-translate-text-icon"]').style.display = '';
            }

            instance.querySelector('[data-entity="hide-original-comment"]').addEventListener("click", (event) => {

                const reviewId = event.currentTarget.getAttribute('review-id');
                const domElements = event.composedPath();
                const userReview = domElements.find(element =>
                    element.tagName && element.tagName.toLowerCase() === 'user-review'
                );
                const userCommentsContainer = event.currentTarget.closest('[name="user-comments-container"]');
                const translatedPositiveComment = userCommentsContainer.querySelector('[name="positive-comment"]') ? userCommentsContainer.querySelector('[name="positive-comment"]').assignedElements() : null;
                const translatedNegativeComment = userCommentsContainer.querySelector('[name="negative-comment"]') ? userCommentsContainer.querySelector('[name="negative-comment"]').assignedElements() : null;

                if (userReview && (typeof this.translateCommentClick == 'function') && ((translatedPositiveComment && translatedPositiveComment.length > 0 && translatedPositiveComment[0].innerHTML.trim() === '')
                    || (translatedNegativeComment && translatedNegativeComment.length > 0 && translatedNegativeComment[0].innerHTML.trim() === ''))) {
                    this.translateCommentClick(reviewId, userReview);
                } else {
                    this._toggleOriginalComment(
                        userCommentsContainer,
                        'none',
                        'block'
                    );
                }
            });
        } else {
            instance.querySelector('[name="show-comments-container"]').remove();
        }
    }

    _toggleOriginalComment(instance, originalCommentDisplay, commentDisplay) {
        instance.querySelectorAll('[data-entity="comment"]').forEach((comment) => {
            comment.style.display = commentDisplay;
        });

        instance.querySelectorAll('[data-entity="original-comment"]').forEach((comment) => {
            comment.style.display = originalCommentDisplay;
        });

        if (commentDisplay === 'block') {
            instance.querySelector('[name="show-translate-text"]').style.display = '';
            instance.querySelector('[name="show-translate-text-icon"]').style.display = '';
        } else {
            instance.querySelector('[name="show-translate-text"]').style.display = commentDisplay;
            instance.querySelector('[name="show-translate-text-icon"]').style.display = commentDisplay;
        }
        instance.querySelector('[data-entity="show-original-comment"]').style.display = commentDisplay;
        instance.querySelector('[data-entity="hide-original-comment"]').style.display = originalCommentDisplay;
    }

    _fillNegativeComment(instance, userReview) {
        if (!this._checkElementExists(userReview.negative_comment)) {
            instance.querySelector('[name="negative-comment-container"]').remove();
        }
    }

    _fillPositiveComment(instance, userReview) {
        if (!this._checkElementExists(userReview.positive_comment)) {
            instance.querySelector('[name="positive-comment-container"]').remove();
        }
    }

    _fillComment(instance, userReview) {
        if (!this._checkElementExists(userReview.comment)) {
            instance.querySelector('[name="comment-container"]').remove();
        }
    }

    _fillTranslatedComments(instance, userReview) {
        const instanceShadowRoot = instance._shadowRoot
        if (!this._checkElementExists(userReview.positive_comment) || (userReview.positive_comment && userReview.positive_comment.default_comment == '')) {
            if (instanceShadowRoot.querySelector('[name="positive-comment-container"]')) {
                instanceShadowRoot.querySelector('[name="positive-comment-container"]').remove();
            }
        } else {
            instanceShadowRoot.querySelector('[data-comment="positive-comment"]').innerHTML = userReview.positive_comment.default_comment;
            instance.querySelector('[slot="positive-comment"]').innerHTML = userReview.positive_comment.default_comment;
        }
        if (!this._checkElementExists(userReview.negative_comment) || (userReview.negative_comment && userReview.negative_comment.default_comment == '')) {
            if (instanceShadowRoot.querySelector('[name="negative-comment-container"]')) {
                instanceShadowRoot.querySelector('[name="negative-comment-container"]').remove();
            }
        } else {
            instanceShadowRoot.querySelector('[data-comment="negative-comment"]').innerHTML = userReview.negative_comment.default_comment;
            instance.querySelector('[slot="negative-comment"]').innerHTML = userReview.negative_comment.default_comment;
        }
        if (userReview.replies && userReview.replies.length > 0) {
            if ((!this._checkElementExists(userReview.replies[0].default_comment) || (userReview.replies[0].default_comment == ''))) {
                if (instanceShadowRoot.querySelector('[name="replies-container"]')) {
                    instanceShadowRoot.querySelector('[name="replies-container"]').remove();
                }
            } else {
                instanceShadowRoot.querySelector('[data-comment="replies-comment"]').innerHTML = this._cleanReplyComment(userReview.replies[0].default_comment);
            }
        }
    }

    _fillReplyContainer(replyTemplate, reply) {
        let replyContainer = replyTemplate.cloneNode(true)
        replyContainer.querySelector('[name="author"]').innerHTML = reply.author;
        replyContainer.querySelector('[data-entity="comment"]').innerHTML = reply.comment;

        if (this._checkElementExists(reply.default_original_comment)) {
            replyContainer.querySelector('[name="original-comment"]').innerHTML = this._cleanReplyComment(reply.default_original_comment);
        }
        return replyContainer;
    }

    _cleanReplyComment(reply) {
        return reply.replace(/<[^>]*>/g, '').trimStart();
    }

    _showSurveyImages(images, instance) {
        let imagesContainer = instance.querySelector('[name="survey-images-container"]');

        images.forEach((item, index) => {
            let imagePreview = document.createElement('img');
            imagePreview.classList.add('survey-image');
            imagePreview.setAttribute('loading', 'lazy');
            imagePreview.src = item;
            imagePreview.addEventListener('click', (event) => {
                this._openReviewGallery(index, images);
            });
            imagesContainer.appendChild(imagePreview);
        });
    }

    _openReviewGallery(index, images, galleryModal = null, showGalleryList = false) {
        if (galleryModal) {
            this.galleryModal = galleryModal;
        } else {
            this.galleryModal = document.querySelector('[data-gallery-modal="hotel-gallery-survey"]');
        }

        if (this.galleryModal.length === 0) {
            return;
        }

        this.galleryModal.shadowRoot.querySelector('[name="modal-body"]').innerHTML = '';
        this.galleryModal.shadowRoot.querySelector('[name="modal-body-sidebar"]').innerHTML = '';

        this._createReviewGalleryList(images);
        let userReview = this._createUserReviewGalleryList();

        this.galleryModal.shadowRoot.querySelector('[name="modal-body"]').append(this.imageGalleryList);
        this.galleryModal.shadowRoot.querySelector('[name="modal-body-sidebar"]').append(userReview);

        this.galleryModal._openModal(showGalleryList);
        if (showGalleryList) {
            this.imageGalleryList._onShowImageGalleryList(index, true);
        } else {
            this.imageGalleryList._onShowImageGallerySlider(index);
        }

        return userReview;
    }

    _createReviewGalleryList(images) {
        this.imageGalleryList = document.createElement('image-gallery-list');
        this.imageGalleryList.setAttribute('data-entity', 'gallery-hotel-survey');
        this.imageGalleryList.setAttribute('stylesheet', this.stylesheet);
        const galleryListImages = [{
            'img': images
        }];
        this.imageGalleryList.setAttribute('image-urls', JSON.stringify(galleryListImages));
        this.imageGalleryList.connectedCallback();
        this.imageGalleryList.initializeSwiper(this.swiper);
    }

    _createUserReviewGalleryList(userReviewTmp = null) {
        if (!userReviewTmp) {
            userReviewTmp = this.userReview;
        }
        userReviewTmp.images = [];
        let userReview = document.createElement('user-review');
        userReview.setSwiper(this.swiper);
        userReview.setAttribute('stylesheet', this.stylesheet);
        userReview.setAttribute('user-review', JSON.stringify(userReviewTmp));
        userReview.setAttribute('user-review-id', userReviewTmp.id);
        if (this._checkElementExists(this.hotelInfo)) {
            userReview.setAttribute('hotel-info', JSON.stringify(this.hotelInfo));
        }
        if (this._checkElementExists(this.translations)) {
            userReview.setAttribute('translations', JSON.stringify(this.translations));
        }
        userReview.setAttribute('hotel-info-visible', true);
        userReview.setAttribute('class', 'full-width');
        userReview.setAttribute('collapsed', true);
        userReview.setAttribute('slotted', '0');
        if (this._showTranslateReviews) {
            userReview.showTranslateReviews = true;
            userReview.isGalleryReview = true;
        }
        userReview.imageGalleryList = this.imageGalleryList;

        userReview.setSwiper(this.swiper);

        return userReview;
    }

    _fillHotelCategory(categoryContainer, name, quantity) {
        if (quantity < 1) return;
        for (let i = 0; i < quantity; i++) {
            let category = document.createElement('i');
            category.classList.add('ci', 'ci-' + name, 'ci-s-17', 'mr-1', 'color-category-light');
            categoryContainer.appendChild(category);
        }
    }

    _addCollapse(instance, userReview) {
        if (this._checkElementExists(this.translations) && this._checkElementExists(this.translations.showMore) &&
            this._checkElementExists(this.translations.showLess)) {
            instance.querySelector('[name="show-more"]').innerHTML = this.translations.showMore;
            instance.querySelector('[name="show-less"]').innerHTML = this.translations.showLess;
        }
        let userReviewBottom = instance.querySelector('[name="user-review-bottom"]');
        if (userReviewBottom && this._checkElementExists(userReview.positive_comment) &&
            this._checkElementExists(userReview.positive_comment.default_original_comment)) {
            userReviewBottom.classList.remove('flex-justify-content-end');
            userReviewBottom.classList.add('flex-justify-content-between');
        }
        instance.querySelector('[name="show-more-container"]').classList.toggle('hidden');
        let userComments = instance.querySelector('[name="user-comments"]');
        userComments.classList.add('collapsed');

        instance.querySelector('[name="show-more-container"]').addEventListener('click', (event) => {
            userComments.classList.toggle('collapsed');
            event.currentTarget.querySelector('[name="show-more"]').classList.toggle('hidden');
            event.currentTarget.querySelector('[name="show-less"]').classList.toggle('hidden');
        });
    }

    _checkElementExists(element) {
        if (typeof element !== 'undefined' && element) {
            return true;
        }
        return false;
    }

    setSwiper(swiper) {
        this.swiper = swiper;
    }

    set showTranslateReviews(value) {
        this._showTranslateReviews = Boolean(value);
    }
    get showTranslateReviews() {
       return this._showTranslateReviews;
    }
}
